<script>
  // Deleting the saved query being edited: its own card under the editor, a red
  // button that asks first. Lives in the edit screen, not on the panel, so it is
  // never one stray click away while reading. `ondelete` () → Promise; the
  // caller deletes and moves on.
  import Section from './Section.svelte';
  import Panel from './Panel.svelte';
  import Button from './Button.svelte';
  import Alert from './Alert.svelte';

  let { label, ondelete } = $props();
  let asking = $state(false);
  let deleting = $state(false);
  let error = $state(null);

  async function confirm() {
    deleting = true; error = null;
    try { await ondelete(); asking = false; }
    catch (e) { error = e.message; }
    finally { deleting = false; }
  }
</script>

<Section title="Delete this comparison">
  <Panel>
    <p class="wf2-text">Removes it from your Pod and from Comparisons. Its cubes and source data are not changed.</p>
    {#if asking}
      <Alert title={`Delete “${label}”?`} variant="warning">
        <div class="wf2-row" style="gap:12px">
          <Button variant="danger" disabled={deleting} onclick={confirm}>{deleting ? 'Deleting…' : 'Delete'}</Button>
          <Button variant="ghost" disabled={deleting} onclick={() => (asking = false)}>Keep it</Button>
        </div>
      </Alert>
    {:else}
      <div class="wf2-row">
        <Button variant="danger" onclick={() => { asking = true; error = null; }}>Delete comparison</Button>
      </div>
    {/if}
    {#if error}
      <Alert title="Could not delete" variant="danger"><p class="mono">{error}</p></Alert>
    {/if}
  </Panel>
</Section>
